import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Scroll from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faUser, faKey } from "@fortawesome/free-solid-svg-icons";
import FormErrorBox from "../Reusable/FormErrorBox";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { postLoginAPI } from "../../API/gateway";
import { useAuthStore } from "../../stores/auth-store";
import toast from "react-hot-toast";

function Login() {
  const [errors, setErrors] = useState({});
  const [validation, setValidation] = useState({
    username: false,
    password: false,
  });
  const [userprofile, setProfile] = useLocalStorage("RHEA_CMS_USER_PROFILE");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const authStore = useAuthStore();

  function onLoginSuccess(profile) {
    setProfile(profile);
    authStore.setUser(profile);
    toast.success("Login success");
    navigate(profile?.role === "admin" ? "/dashboard" : "/org-dashboard");
  }

  function onLoginError(apiErr) {
    toast.error(apiErr.message);
    console.log(apiErr);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onLoginDone() {
    // toast.success("Login success");
  }

  function onUsernameChange(e) {
    setUsername(e.target.value);
    validation["username"] = false;
    setValidation(validation);
  }

  function onPasswordChange(e) {
    setPassword(e.target.value);
    validation["password"] = false;
    setValidation(validation);
  }

  function onButtonClick(e) {
    var newErrors = {};
    var newValidation = {};
    if (username === undefined || username === null || username === "") {
      newErrors["username"] = "value is missing";
    } else {
      newValidation["username"] = true;
    }
    if (password === undefined || password === null || password === "") {
      newErrors["password"] = "value is missing";
    } else {
      newValidation["password"] = true;
    }

    setErrors(newErrors);
    setValidation(newValidation);

    if (Object.keys(newErrors).length > 0) {
      var scroll = Scroll.animateScroll;
      scroll.scrollToTop();
    } else {
      console.log("successful validation, submitting to API server.");

      const postData = {
        email: username,
        password: password,
      };
      postLoginAPI(postData, onLoginSuccess, onLoginError, onLoginDone);
    }
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);
    }

    return () => (mounted = false);
  }, []);

  return (
    <>
      <div class="container column is-12">
        <div class="section">
          <section class="hero is-fullheight">
            <div class="hero-body">
              <div class="container">
                <div class="columns is-centered">
                  <div class="box is-rounded column is-one-third-tablet">
                    {/* Start Logo */}
                    <nav class="level pb-5">
                      <div class="level-item has-text-centered">
                        <figure class="image">
                          <img
                            src="https://www.getrhea.com/wp-content/themes/duet/images/logo-full.png"
                            style={{ width: "256px" }}
                          />
                        </figure>
                      </div>
                    </nav>
                    {/* End Logo */}

                    <form>
                      <h1 className="title is-3 has-text-centered">
                        Staff Sign In
                      </h1>
                      <FormErrorBox errors={errors} />

                      <div class="field">
                        <label class="label is-small has-text-grey-light">
                          USERNAME
                        </label>
                        <div class="control has-icons-left has-icons-right">
                          <input
                            class={`input ${
                              errors && errors.username && "is-danger"
                            } ${
                              validation && validation.username && "is-success"
                            }`}
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={onUsernameChange}
                            autocapitalize="none"
                          />
                          <span class="icon is-small is-left">
                            <FontAwesomeIcon className="fas" icon={faUser} />
                          </span>
                        </div>
                        {errors && errors.username && (
                          <p class="help is-danger">{errors.username}</p>
                        )}
                      </div>

                      <div class="field">
                        <label class="label is-small has-text-grey-light">
                          PASSWORD
                        </label>
                        <div class="control has-icons-left has-icons-right">
                          <input
                            class={`input ${
                              errors && errors.password && "is-danger"
                            } ${
                              validation && validation.password && "is-success"
                            }`}
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={onPasswordChange}
                          />
                          <span class="icon is-small is-left">
                            <FontAwesomeIcon className="fas" icon={faKey} />
                          </span>
                        </div>
                        {errors && errors.password && (
                          <p class="help is-danger">{errors.password}</p>
                        )}
                      </div>
                      <br />
                      <button
                        class="button is-block is-fullwidth is-primary"
                        type="button"
                        onClick={onButtonClick}
                      >
                        Login <FontAwesomeIcon icon={faArrowRight} />
                      </button>
                    </form>
                    <br />
                    <nav class="level">
                      <div class="level-item has-text-centered">
                        <div>
                          <Link
                            to="/forgot-password"
                            className="is-size-7-tablet"
                          >
                            Forgot Password?
                          </Link>
                        </div>
                      </div>
                      {/*
                                            <div class="level-item has-text-centered">
                                                <div>
                                                    <Link to="/register-step-1" className="is-size-7-tablet">Create an Account</Link>
                                                </div>
                                            </div>
                                            */}
                    </nav>
                  </div>
                  {/* End box */}
                </div>
              </div>
              {/* End container */}
            </div>
            {/* End hero-body */}
          </section>
        </div>
      </div>
    </>
  );
}

export default Login;
